import { supabase } from "@/integrations/supabase/client";

export interface UserBehaviorData {
  total_views: number;
  total_reads: number;
  total_audio_plays: number;
  total_reading_time: number;
  favorite_categories: number[];
  recent_books: number[];
  completed_books: number[];
}

export interface BookRecommendation {
  id: number;
  title: string;
  authors?: { id: number; name: string }[];
  categories?: { id: number; name: string }[];
  cover_image?: string;
  cover_bg_color?: string;
  reading_time?: number;
  rating?: number;
  view_count?: number;
  summary_contents?: { id: number; audio_url?: string }[];
  recommendation_score: number;
  recommendation_reasons: string[];
}

export interface RecommendationsResponse {
  recommendations: BookRecommendation[];
  userBehavior: UserBehaviorData;
  metadata: {
    totalBooksAnalyzed: number;
    userCategoriesCount: number;
    generatedAt: string;
  };
}

export const fetchUserRecommendations = async (
  userId: number,
  limit: number = 10
): Promise<RecommendationsResponse> => {
  try {
    // Build the function path with query parameters
    const functionPath = `user-recommendations?userId=${userId}&limit=${limit}`;
    
    const { data, error } = await supabase.functions.invoke(functionPath, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (error) {
      console.error("Error calling user-recommendations function:", error);
      throw new Error(`Failed to fetch recommendations: ${error.message}`);
    }

    return data;
  } catch (error) {
    console.error("Error fetching user recommendations:", error);
    throw error;
  }
};